import ErrorSuspense from "./ErrorSuspense";

export default ErrorSuspense;
